import { useEffect, useRef } from 'react';
import './Loader.scss';
import gsap from 'gsap';

function Loader() {
    const oneRef = useRef(null);
    const twoRef = useRef(null);
    const threeRef = useRef(null);
    const fourRef = useRef(null);

    useEffect(() => {
        const refs = [
            oneRef,
            twoRef,
            threeRef,
            fourRef,
        ]
        const master = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.2
        });

        refs.forEach((ref, index) => {
            const elementTimeline = gsap.timeline();
        
            elementTimeline
                .to(ref.current, {
                    rotation: "+=180",
                    scale: 1.2,
                    duration: .7,
                    ease: "power2.in"
                })
                .to(ref.current, {
                    rotation: "+=180",
                    scale: 1,
                    duration: .7,
                    ease: "power2.out"
                });
            
            master.add(elementTimeline, index * 0.12);
        });

        return () => {
            master.kill();
        };
    }, []);

    return (
        <div className='loader-wrapper'>
                <div className='spinner-container one' ref={oneRef}>
                    <div className='spin-wrapper'>
                        <div className='spin' />
                    </div>
                </div>
                <div className='spinner-container two' ref={twoRef}>
                    <div className='spin-wrapper'>
                        <div className='spin' />
                    </div>
                </div>
                <div className='spinner-container three' ref={threeRef}>
                    <div className='spin-wrapper'>
                        <div className='spin' />
                    </div>
                </div>
                <div className='spinner-container four' ref={fourRef}>
                    <div className='spin-wrapper'>
                        <div className='spin' />
                    </div>
                </div>

            <div className='loader-text'>
                Загрузка...
            </div>
        </div>
    )
}

export default Loader;